//@ts-check
angular.module('app').controller('CandidateProfileEmailThankYouCtrl', ["$scope", "$rootScope", "$stateParams", "Server", "Upload", "overlaySpinner", function ($scope, $rootScope, $stateParams, Server, Upload, overlaySpinner) {
  $rootScope.showBanner = true;
}]);
